module.exports = __webpack_public_path__ + "static/media/acura-off-app-provider-icon.33b1bf71.svg";